import {
  PostVideoCommentReportOptions,
  PostVideoCommentReportFields,
} from '@vimeo/gctl-api/fetchers/video/comment/report';
import {
  PostVideoReportFields,
  PostVideoReportOptions,
} from '@vimeo/gctl-api/fetchers/video/report';

export const REASON_UNSELECTED = 'unselected';
export type VideoReason = PostVideoReportOptions<PostVideoReportFields>['variables']['reason'];
export type VideoCommentReason =
  PostVideoCommentReportOptions<PostVideoCommentReportFields>['variables']['reason'];
export type Reason = VideoReason | VideoCommentReason | typeof REASON_UNSELECTED;

export interface ReportReason {
  title: string;
  description: string;
  value: string;
}
